import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles/index';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Divider from '@material-ui/core/Divider';
import CastIcon from '@material-ui/icons/CastConnected';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CarIcon from '@material-ui/icons/DirectionsCar';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import ChartIcon from '@material-ui/icons/InsertChart';
import StationIcon from '@material-ui/icons/LocalGasStation';
import TruckIcon from '@material-ui/icons/LocalShipping';
import RailIcon from '@material-ui/icons/DirectionsRailway';
import UsersIcon from '@material-ui/icons/People';
import SettingsIcon from '@material-ui/icons/Settings';
import CodeIcon from '@material-ui/icons/Code';

import { MuiThemeProvider } from '@material-ui/core/styles';
import { Link, Route } from 'react-router-dom';
import { darkTheme } from '../themes';

import aiIcon from '../images/icons/ai.svg';
import pipelineIcon from '../images/icons/pipeline.svg';
import puzzleIcon from '../images/icons/puzzleIcon.svg';
import robotIcon from '../images/icons/robot.svg';
import bankIcon from '../images/icons8Bank.svg';
import moneyTransfer from '../images/moneyTransfer.svg';
import testTubeSvg from '../images/testTube.svg';
import { version } from '../libs/utility';

const styles = () => {
	return {
		icon: {
			margin: 3,
		},
		iconText: {
			paddingLeft: 8,
			paddingTop: 2,
			color: 'white',
		},
		formulaIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundImage: `url('${testTubeSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			color: 'rgba(255, 255, 255, 1)',
			margin: 0,
		},
		accountingIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundImage: `url('${bankIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			color: 'rgba(255, 255, 255, 1)',
			margin: 0,
		},
		puzzleIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundImage: `url('${puzzleIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			color: 'rgba(255, 255, 255, 1)',
			margin: 0,
		},
		aiIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundImage: `url('${aiIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			color: 'rgba(255, 255, 255, 1)',
			margin: 0,
		},
		robotIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundImage: `url('${robotIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			color: 'rgba(255, 255, 255, 1)',
			margin: 0,
		},
		pipelineIcon: {
			display: 'inline-block',
			width: 24,
			height: 24,
			backgroundImage: `url('${pipelineIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			color: 'rgba(255, 255, 255, 1)',
			margin: 0,
		},
		billingIcon: {
			display: 'inline-block',
			width: 26,
			height: 26,
			backgroundImage: `url('${moneyTransfer}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			color: 'rgba(255, 255, 255, 1)',
			margin: 0,
		},
		selected: {
			backgroundColor: '#2b95f3',
			height: '3px',
			margin: '0px 16px',
			top: '-4px',
			position: 'relative',
			transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
		},
		nested: {
			paddingLeft: 18,
			marginTop: -10,
			marginBottom: -10,
			textDecoration: 'none',
		},
		nestedItem: {
			paddingTop: 7,
			paddingBottom: 7,
		},
		notNested: {
			marginTop: 9,
			textDecoration: 'none',
		},
		nestedRoot: {
			paddingLeft: 5,
			color: 'white',
		},
		nestedText: {
			color: '#fff',
			lineHeight: 1.3,
			fontWeight: 300,
		},
		nestedIcon: {
			borderBottom: '1px solid white',
			borderLeft: '1px solid white',
			margin: 0,
			position: 'relative',
			opacity: 0.4,
			top: -10,
			left: -7,
			width: 18,
			height: 18,
		},
		tightIcon: {
			marginRight: 0,
			minWidth: 'auto',
		},
		logout: {
			color: 'white',
			textDecoration: 'none',
		},
	};
};

class LeftDrawer extends Component {
	constructor(props) {
		super(props);
		this.handleLogout = this.handleLogout.bind(this);
		this.state = {
			open: true,
		};
	}

	handleLogout() {
		this.props.logout();
	}

	render() {
		const { authUser, drawerOpen, drawerPaper, classes } = this.props;
		if (!authUser) {
			return null;
		}
		const canViewUsers = _.get(authUser, ['permissions', 'canViewUsers']);
		const canImpersonateUsers = _.get(authUser, ['permissions', 'canImpersonateUsers']);
		const canViewContracts = _.get(authUser, ['permissions', 'canRwContracts']);
		const canViewBillingAutomation = _.get(authUser, ['permissions', 'canViewBillingAutomation']);
		const canViewInventoryAllocation = _.get(authUser, ['permissions', 'canRwInventoryAllocation']);
		const canViewCogs = _.get(authUser, ['permissions', 'canRunCostOfGoodsReports']);
		const canViewFreightReport = _.get(authUser, ['permissions', 'canRunFreightReports']);
		const canViewPlc = _.get(authUser, ['permissions', 'canRwPlc']);
		const canViewRinCost = _.get(authUser, ['permissions', 'canRwRinCost']);
		const canViewPricingNotifications = _.get(authUser, [
			'permissions',
			'canViewPricingNotifications',
		]);

		const menuStruct = [
			{
				link: '/dashboard',
				icon: <DashboardIcon className={classes.icon} />,
				label: 'Dashboard',
				allowRoles: ['externalLogistics', 'externalReporting'],
			},
			{
				link: '/stations',
				route: '/station*',
				icon: <StationIcon className={classes.icon} />,
				label: 'Stations',
				//- externalLogistics keeps the station APIs but not the listing screen
				allowRoles: ['externalReporting'],
			},
		];

		if (canViewBillingAutomation) {
			menuStruct.push(
				{
					link: '/apAutomation',
					exact: true,
					icon: <div className={classes.robotIcon} />,
					label: 'AP Automation',
				},
				{
					nested: true,
					link: '/apAutomation/apProcessedEmails',
					route: '/apAutomation/apProcessedEmails',
					label: 'AP Emails',
				},
				{
					nested: true,
					link: '/apAutomation/apIngestions',
					route: '/apAutomation/apIngestions',
					label: 'AP Ingestion',
				},
				{
					nested: true,
					link: '/apAutomation/apIngestionResults',
					route: '/apAutomation/apIngestionResult*',
					label: 'AP Result Triage',
				},
				{
					nested: true,
					link: '/apAutomation/stationMappings',
					route: '/apAutomation/stationMappings',
					label: 'Station Mappings',
				}
			);

			menuStruct.push(
				{
					link: '/ocr',
					exact: true,
					icon: <div className={classes.aiIcon} />,
					label: 'AR Automation',
				},
				{
					nested: true,
					link: '/ocr/ocrIngestions',
					route: '/ocr/ocrIngestions',
					label: 'AR Ingestion',
				},
				{
					nested: true,
					link: '/ocr/ocrIngestionResults',
					route: '/ocr/ocrIngestionResult*',
					label: 'AR Result Triage',
				}
			);
		}

		if (canViewContracts || canViewInventoryAllocation || canViewCogs || canViewFreightReport) {
			menuStruct.push({
				link: '/inventoryManagement',
				exact: true,
				icon: <div className={classes.pipelineIcon} />,
				label: 'Inventory Mgmt.',
			});

			if (canViewContracts) {
				menuStruct.push({
					nested: true,
					link: '/inventoryManagement/fuelContracts',
					route: '/inventoryManagement/fuelContract*',
					label: 'Fuel Contracts',
				});
				menuStruct.push({
					nested: true,
					link: '/inventoryManagement/contractFulfillment',
					route: '/inventoryManagement/contractFulfillment',
					label: 'Contract Fulfillment',
				});
			}

			if (canViewInventoryAllocation) {
				menuStruct.push({
					nested: true,
					link: '/inventoryManagement/inventoryAllocations',
					route: '/inventoryManagement/inventoryAllocation*',
					label: 'Inventory Allocations',
				});
			}

			if (canViewContracts) {
				menuStruct.push({
					nested: true,
					link: '/inventoryManagement/inventoryReports',
					route: '/inventoryManagement/inventoryReports',
					label: 'Inventory Reports',
				});
			}

			if (canViewCogs) {
				menuStruct.push({
					nested: true,
					link: '/inventoryManagement/profitReports',
					label: 'Profit Reports',
				});
			}
			if (canViewFreightReport) {
				menuStruct.push({
					nested: true,
					link: '/inventoryManagement/freightReports',
					label: 'Freight Reports',
				});
			}
			if (canViewContracts) {
				menuStruct.push({
					nested: true,
					link: '/inventoryManagement/balanceSync',
					route: '/inventoryManagement/balanceSync',
					label: 'Balance Sync Status',
				});
			}
		}

		menuStruct.push(
			{
				link: '/reconciliation',
				exact: true,
				icon: <div className={classes.puzzleIcon} />,
				label: 'Reconciliation',
			},
			{
				nested: true,
				link: '/reconciliation/missingStationAr',
				label: 'Missing Station AR',
			},
			{
				nested: true,
				link: '/reconciliation/missingBulkAr',
				label: 'Missing Bulk AR',
			},
			{
				nested: true,
				link: '/reconciliation/missingRackTransferAr',
				label: 'Missing Rack AR',
			},
			{
				link: '/billing',
				exact: true,
				icon: <div className={classes.billingIcon} />,
				label: 'Accounts Payable',
			},
			{
				nested: true,
				link: '/billing/vendorBills',
				label: 'Vendor Bills',
			},
			{
				nested: true,
				link: '/billing/queuedVendorBills',
				label: 'Bill Queue',
			},
			{
				nested: true,
				link: '/billing/quickbooksMapping',
				label: 'Quickbooks Mapping',
			},
			{
				link: '/accounting',
				exact: true,
				icon: <div className={classes.accountingIcon} />,
				label: 'Accounts Receivable',
			},
			{
				nested: true,
				link: '/accounting/stationInvoices',
				label: 'Station Invoices',
			},
			{
				nested: true,
				link: '/accounting/creditMemos',
				label: 'Credits & Rebills',
			},
			{
				nested: true,
				link: '/accounting/bulkInvoices',
				label: 'Bulk Invoices',
			},
			{
				nested: true,
				link: '/accounting/rackTransfers',
				label: 'Rack Transfers',
			},
			{
				nested: true,
				link: '/accounting/trueUpInvoices',
				label: 'True Up Invoices',
			},
			{
				nested: true,
				link: '/accounting/reporting',
				label: 'Reporting',
			},
			{
				nested: true,
				link: '/accounting/invoiceSearch',
				label: 'Invoice Search',
			},
			{
				nested: true,
				link: '/accounting/rackTransferSearch',
				label: 'Rack Trans Search',
			},
			{
				nested: true,
				link: '/accounting/mhxBols',
				label: 'MHX BOLs',
			},
			{
				nested: true,
				link: '/accounting/usdgBols',
				label: 'IECFT BOLs',
			},
			{
				nested: true,
				link: '/accounting/sanYsidroBols',
				label: 'San Ysidro BOLs',
			},
			{
				nested: true,
				link: '/accounting/candoBols',
				label: 'Cando BOLs',
			},
			{
				nested: true,
				link: '/accounting/vanGFowlerBols',
				label: 'Van G Fowler BOLs',
			},
			{
				nested: true,
				link: '/accounting/interstateBols',
				label: 'InterState BOLs',
			},
			{
				nested: true,
				link: '/accounting/superiorSubmissions',
				label: 'Superior Data',
			},

			{
				link: '/railcars',
				exact: true,
				icon: <RailIcon className={classes.icon} />,
				label: 'Railcars',
				allowRoles: ['externalReporting'],
			},
			{
				nested: true,
				link: '/railcars/listing',
				label: 'Listing',
				allowRoles: ['externalReporting'],
			},
			{
				nested: true,
				link: '/railcars/masterSheet',
				label: 'Master Sheet',
			},
			{
				nested: true,
				link: '/railcars/export',
				label: 'Export',
				allowRoles: ['externalReporting'],
			},
			{
				link: '/logistics',
				exact: true,
				icon: <TruckIcon className={classes.icon} />,
				label: 'Logistics',
				allowRoles: ['externalLogistics'],
			},
			{
				nested: true,
				link: '/logistics/monitoring',
				label: 'Monitoring',
				allowRoles: ['externalLogistics'],
			},
			{
				nested: true,
				link: '/logistics/inventory',
				label: 'Inventory',
				allowRoles: ['externalLogistics'],
			},
			{
				nested: true,
				link: '/logistics/deliveries',
				label: 'Station Deliveries',
				allowRoles: ['externalLogistics'],
			},
			{
				nested: true,
				link: '/logistics/bulkDeliveries',
				route: '/logistics/bulkDeliver*',
				label: 'Bulk Deliveries',
			},
			{
				nested: true,
				link: '/logistics/carriers',
				route: '/logistics/carrier*',
				label: 'Carriers',
			},
			{
				nested: true,
				link: '/logistics/terminals',
				route: '/logistics/terminal*',
				label: 'Terminals',
			},
			{
				nested: true,
				link: '/logistics/suppliers',
				route: '/logistics/supplier*',
				label: 'Fuel Vendors and Suppliers',
			},
			{
				nested: true,
				link: '/logistics/loadingAssignments',
				route: '/logistics/loadingAssignments*',
				label: 'Loading Numbers',
			},
			{
				nested: true,
				link: '/logistics/bulkCustomers',
				route: '/logistics/bulkCustomer*',
				label: 'Bulk Customers',
			},
			{
				nested: true,
				link: '/logistics/deliverySearch',
				route: '/logistics/deliverySearch*',
				label: 'Delivery Search',
				allowRoles: ['externalLogistics'],
			},
			{
				nested: true,
				link: '/logistics/activityLogSearch',
				route: '/logistics/activityLogSearch*',
				label: 'Activity Log',
				allowRoles: ['externalLogistics'],
			},
			{
				nested: true,
				link: '/system/tankScrub',
				route: '/system/tankScrub',
				label: 'Tank Scrub',
			}
		);

		if (canViewPricingNotifications) {
			menuStruct.push({
				link: '/notificationJobs',
				route: '/notificationJob*',
				icon: <CastIcon className={classes.icon} />,
				label: 'Notification Jobs',
			});
		}

		menuStruct.push(
			{
				link: '/formulas',
				exact: true,
				icon: <div className={classes.formulaIcon} />,
				label: 'Formulas',
			},
			{
				nested: true,
				link: '/formulas/blends',
				route: '/formulas/blends',
				label: 'Blend Calculator',
			},
			{
				nested: true,
				link: '/invoiceProductMatrix',
				route: '/invoiceProductMatrix',
				label: 'Product Matrix',
			}
		);

		if (canViewPlc) {
			menuStruct.push({
				nested: true,
				link: '/formulas/plcChanges',
				route: '/formulas/plcChanges',
				label: 'PLC Updates',
			});

			menuStruct.push({
				nested: true,
				link: '/formulas/gmAdderChanges',
				route: '/formulas/gmAdderChanges',
				label: 'GM Adder Updates',
			});
		}

		if (canViewRinCost) {
			menuStruct.push({
				nested: true,
				link: '/formulas/rinCostChanges',
				route: '/formulas/rinCostChanges',
				label: 'RIN Cost Updates',
			});
		}

		menuStruct.push(
			{
				link: '/reports',
				exact: true,
				icon: <ChartIcon className={classes.icon} />,
				label: 'Reports',
				allowRoles: ['externalReporting'],
			},
			{
				nested: true,
				link: '/reports/totalVolume',
				label: 'Total Sales',
				allowRoles: ['externalReporting'],
			},
			{
				nested: true,
				link: '/reports/stationVolume',
				label: 'Station Sales',
				allowRoles: ['externalReporting'],
			},
			{
				nested: true,
				link: '/reports/newStationDashboard',
				label: 'New Station Board',
				allowRoles: ['externalReporting'],
			},
			{
				nested: true,
				link: '/reports/salesExport',
				label: 'Sales Export',
				allowRoles: ['externalReporting'],
			},
			{
				nested: true,
				link: '/reports/fuelForecast/includeSpecialEvents',
				label: 'Fuel Forecast',
				allowRoles: ['externalReporting'],
			},
			{
				nested: true,
				link: '/reports/opisPricing',
				label: 'OPIS Pricing',
				allowRoles: ['externalReporting'],
			},
			{
				link: '/retailPricing',
				exact: true,
				icon: <CarIcon className={classes.icon} />,
				label: 'Retail Management',
			},
			{
				nested: true,
				link: '/reports/retailPrices',
				label: 'Retail Prices',
			},
			{
				nested: true,
				link: '/retailPricing/pricingRequests',
				label: 'SMS Requests',
			},
			{
				nested: true,
				link: '/retailPricing/addIgnore',
				label: 'Ignore List',
			},
			{
				nested: true,
				link: '/retailPricing/import',
				label: 'Pricing Import',
			},
			{
				nested: true,
				link: '/rebateCampaign/rebateCampaigns',
				route: '/rebateCampaign/rebateCampaign*',
				label: 'Rebate Campaigns',
			}
		);

		if (canViewUsers) {
			menuStruct.push({
				link: '/users',
				route: '/users*',
				icon: <UsersIcon className={classes.icon} />,
				label: 'Users',
			});
		}

		//- Last in the list on purpose: operational plumbing, not day-to-day work. No
		//- allowRoles, so the role filter below keeps it employee-only.
		menuStruct.push(
			{
				link: '/system',
				exact: true,
				icon: <SettingsIcon className={classes.icon} />,
				label: 'System',
			},
			{
				nested: true,
				link: '/system/tankDailySales',
				route: '/system/tankDailySales',
				label: 'Tableau Sales Data',
			},
			{
				nested: true,
				link: '/system/supportedDocuments',
				route: '/system/supportedDocuments',
				label: 'Supported Docs',
			}
		);

		if (canImpersonateUsers) {
			menuStruct.push({
				nested: true,
				link: '/system/viewAs',
				route: '/system/viewAs',
				label: 'View As',
			});
		}

		//- DEV: everything below is visible ONLY to dwp (userId 14). Keeping it in one
		//- section makes it obvious what the rest of the team does not see. The APIs
		//- behind these pages enforce the same userId gate server-side.
		if (authUser.userId === 14) {
			menuStruct.push(
				{
					link: '/ocr/ocrGuides',
					route: '/dev', //- never matches: header itself is never highlighted
					icon: <CodeIcon className={classes.icon} />,
					label: 'DEV',
				},
				{
					nested: true,
					link: '/ocr/ocrGuides',
					route: '/ocr/ocrGuide*',
					label: 'AR Schemas',
				},
				{
					nested: true,
					link: '/system/migrations',
					route: '/system/migrations',
					label: 'Migrations',
				}
			);
		}

		const { role } = authUser;
		let menuStructFiltered;
		if (role === 'employee') {
			menuStructFiltered = menuStruct;
		} else {
			menuStructFiltered = menuStruct.filter(({ allowRoles }) => {
				if (_.isEmpty(allowRoles)) {
					return false;
				}
				return _.includes(allowRoles, role);
			});
		}

		return (
			<MuiThemeProvider theme={darkTheme}>
				<Drawer variant="persistent" open={drawerOpen} classes={{ paper: drawerPaper }}>
					<Toolbar style={{ backgroundColor: 'none' }}>
						<Typography
							variant="h6"
							noWrap
							style={{ fontSize: 18, textAlign: 'left', marginTop: 5 }}
						>
							Pearson Fuels
							<div style={{ fontSize: 12, color: '#AAA', marginTop: 3 }}>VERSION {version}</div>
						</Typography>
					</Toolbar>
					<Divider />

					<List style={{ textAlign: 'left' }}>
						{menuStructFiltered.map((menu, i) => {
							if (!menu.nested) {
								return (
									<div key={i} className={classes.notNested}>
										<Link to={menu.link} style={{ textDecoration: 'none' }}>
											<ListItem button>
												<ListItemIcon classes={{ root: classes.tightIcon }}>
													{menu.icon}
												</ListItemIcon>
												<ListItemText primary={menu.label} className={classes.iconText} />
											</ListItem>
											<Route
												exact={menu.exact}
												path={menu.route ? menu.route : menu.link}
												render={() => <div className={classes.selected} />}
											/>
										</Link>
									</div>
								);
							} else {
								return (
									<div key={i} className={classes.nested}>
										<Link key={i} to={menu.link} style={{ textDecoration: 'none' }}>
											<ListItem button className={classes.nestedItem}>
												<ListItemIcon classes={{ root: classes.tightIcon }}>
													<div className={classes.nestedIcon} />
												</ListItemIcon>
												<ListItemText
													primary={menu.label}
													classes={{ root: classes.nestedRoot, primary: classes.nestedText }}
												/>
											</ListItem>
											<Route
												path={menu.route ? menu.route : menu.link}
												render={() => <div className={classes.selected} />}
											/>
										</Link>
									</div>
								);
							}
						})}
					</List>
					<Divider />

					<List style={{ textAlign: 'left' }}>
						<Link to={'/logout'} onClick={this.handleLogout} style={{ textDecoration: 'none' }}>
							<ListItem button>
								<ListItemIcon classes={{ root: classes.tightIcon }}>
									<LogoutIcon className={classes.icon} />
								</ListItemIcon>
								<ListItemText primary="Logout" className={classes.logout} />
							</ListItem>
						</Link>
					</List>
				</Drawer>
			</MuiThemeProvider>
		);
	}
}

LeftDrawer.propTypes = {
	classes: PropTypes.object,
	drawerOpen: PropTypes.bool,
	drawerPaper: PropTypes.string,
	logout: PropTypes.func,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles)])(LeftDrawer);
